import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import React, { useContext, useEffect, useState } from 'react'
import CurrencyInput from 'react-currency-input'
import { TiStarFullOutline, TiStarOutline } from 'react-icons/ti'
import ProgressBar from '../../../components/ProgressBar'
import Context from '../../../context'
import { createValidateCpf } from '../../../services/ClubeApi'

function ValidateDialog() {
  const { openDialogGifs, setOpenDialogGifs } = useContext(Context)

  const handleClose = () => {
    setOpenDialogGifs(false)
  }

  const {
    sendLoading,
    setSendLoading,
    clientData,
    unityId,
    setCupons,
    selectedCupons,
    cpf,
    clearDatas
  } = useContext(Context)

  const { value, setValue } = useContext(Context)
  const { score, setScore } = useContext(Context)
  const { setCreatedMessage } = useContext(Context)
  const { gifts, setGifts } = useContext(Context)
  const { setCpf } = useContext(Context)

  const [maskedValue, setMaskedValue] = useState('0,00')

  const [listGift, setListGift] = useState([])

  useEffect(() => {
    if (gifts?.length > 0) {
      const newArr = gifts.map(item => {
        if (item.situation === 8) {
          return { ...item, used: true }
        }
        return { ...item, used: false }
      })

      setListGift(newArr)
    }
  }, [gifts])

  const handleCheck = id => {
    const tempGift = listGift.map(gift => {
      if (gift.id === id && gift.situation === 7) {
        return { ...gift, situation: 8 }
      }
      if (gift.id === id && gift.situation === 8) {
        return { ...gift, situation: 7 }
      }
      return gift
    })

    setListGift(tempGift)
  }

  const handleFinish = () => {
    setSendLoading(true)
    setGifts(listGift)
    const validateCpf = async () => {
      return createValidateCpf({
        partnerUnitId: unityId,
        value,
        userData: clientData,
        score,
        gifts: listGift,
        // code: selectedCupons,
        totalValue: value,
        discountedValue: 0
      })
    }
    clearDatas()
    setScore(5)
    setValue(0)
    setMaskedValue('0,00')

    handleClose()

    validateCpf().then(r => {
      setCupons()
      setCpf('')
      setSendLoading(false)
      setCreatedMessage(r)
    })
  }

  const handleCurrencyChange = (event, maskedvalue, floatvalue) => {
    setMaskedValue(maskedvalue)
    setValue(floatvalue)
  }

  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={openDialogGifs}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          {sendLoading ? (
            <ProgressBar height="20px" />
          ) : (
            <div>
              {clientData && clientData.name ? (
                <>
                  <h4>{clientData.name || ''}</h4>
                  <span style={{ fontSize: '15px' }}>{cpf || ''}</span>

                  <p style={{ fontSize: 30 }}>
                    {score >= 1 ? (
                      <TiStarFullOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(1)}
                      />
                    ) : (
                      <TiStarOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(1)}
                      />
                    )}
                    {score >= 2 ? (
                      <TiStarFullOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(2)}
                      />
                    ) : (
                      <TiStarOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(2)}
                      />
                    )}
                    {score >= 3 ? (
                      <TiStarFullOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(3)}
                      />
                    ) : (
                      <TiStarOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(3)}
                      />
                    )}
                    {score >= 4 ? (
                      <TiStarFullOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(4)}
                      />
                    ) : (
                      <TiStarOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(4)}
                      />
                    )}
                    {score === 5 ? (
                      <TiStarFullOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(5)}
                      />
                    ) : (
                      <TiStarOutline
                        className="item-click"
                        style={{ color: '#330f87' }}
                        onClick={() => setScore(5)}
                      />
                    )}
                  </p>

                  <div className="form-group">
                    <CurrencyInput
                      value={maskedValue}
                      onChangeEvent={handleCurrencyChange}
                      className="form-control clube-border"
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                    />
                  </div>

                  {listGift.length > 0 && (
                    <>
                      <h4>Selecione o brinde:</h4>
                      <div className="form-group d-flex flex-column align-content-between">
                        {listGift.map(gift => (
                          <div key={gift.id} className="form-check">
                            <input
                              checked={gift.situation === 8}
                              onChange={() => handleCheck(gift.id)}
                              disabled={gift.used}
                              style={{ width: 20, height: 20 }}
                              className="form-check-input"
                              type="checkbox"
                              id={gift.id}
                            />
                            <label
                              style={{
                                height: 20,
                                fontSize: 20,
                                paddingLeft: 10,
                                paddingBottom: 15
                              }}
                              className="form-check-label"
                              htmlFor={gift.id}
                            >
                              {gift.description}
                            </label>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  <div className="form-group d-flex justify-content-end">
                    <button
                      onClick={handleFinish}
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-info clube-btn clube-blue"
                      style={{ width: '100px' }}
                    >
                      Concluir
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">CPF não encontrado</h4>
                    <hr />
                    <p>Ooops, este CPF não foi encontrado na base de dados do Clube</p>
                  </div>
                  <div className="form-group d-flex justify-content-end">
                    <button
                      onClick={() => {}}
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-danger clube-btn"
                      style={{ width: '100px' }}
                    >
                      Fechar
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ValidateDialog
